const practiceOverview = {
  "practice.mode": "Modo de Práctica",
  "practice.title": "Afilando el Filo",
  "practice.description": "La práctica se adapta a tu viaje — reflejando tu progreso, apuntando a tus brechas y afilando lo que más importa.",
};

const practiceSettings = {
  "practice.game.speed": "Velocidad del Juego",
  "practice.difficulty": "Dificultad",
  "practice.scenarios": "Escenarios",
  "practice.awareness.tests": "Pruebas de Memoria",
  "practice.slowtime": "Tiempo lento para Decisiones",
  "practice.level-not-available": "Entrena para desbloquear este nivel",
};

export const practice = {
  ...practiceOverview,
  ...practiceSettings,
};
